/**
 * Created by mIGUEL ON 22/05/2017.
 */
import {Component, ViewChild, ElementRef, OnDestroy, OnInit,Input, Output,EventEmitter  } from '@angular/core';
import { CompanyService } from '../../../services/company.service';
import { AppDataService } from '../../../services/app-data.service';
import {UserService} from "../../../services/user.service";
import {TranslationService} from "../../../services/translation.service";
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import {Buffer} from 'buffer';
import {FormBuilder, FormGroup} from "@angular/forms";
// Importando a biblioteca DXT
declare let Cropper :any;

declare let Swal: any;
declare var $ : any;

@Component({
    selector : 'advertising',
    templateUrl:'advertising.html',
    providers  : []
})
export class Advertising implements OnInit {
  public room=null;
  public advertiseForm:FormGroup
  public videoSource;
  public hasAds=false;
  constructor(public fb : FormBuilder,
    public _companyService: CompanyService,public translate: TranslationService,
              public _appData: AppDataService,public _auth : UserService,private sanitizer: DomSanitizer) {

  }
  @Input() advertiseValue!: string;
  @Output() advertiseValueChange = new EventEmitter<string>();
  onChange(value: string) {
    this._appData.room=this.room;
    this.advertiseValueChange.emit(value);
  }
  closeModal(){
    document.getElementById("advertising-modal").style.display = "none";
  }

  public reload(){
      this.room=this._appData.socialRoom;
      this.advertiseForm = this.fb.group({
        chkAds:true,
        description:this.room.description,
        keyWords:this.room.keyWords
      })
      this.imageSrc=this.room.photo;
      this.videoSource=this.room.video;
      setTimeout(()=>{
          document.getElementById('videoUrl')['value']=this.videoSource
          $('#videoEmbed').attr('src', this.videoSource);
          },1000);
     

  }
  public ngOnInit(): void {
      this.advertiseForm = this.fb.group({
        chkAds:true,
        description:'',
        keyWords:''
      })
  }
  public onFormChange(event: Event){

    let description=    this.advertiseForm.controls['description'].value;
    let keywords=    this.advertiseForm.controls['keyWords'].value;



    this.room.keyWords=keywords;
    this.room.description=description
          setTimeout(()=>{
          document.getElementById('videoUrl')['value']=this.videoSource
          $('#videoEmbed').attr('src', this.videoSource);

          },1000)

    this.save();
  }

  public save(){
    this._companyService.getSocial(this.room).set(this.room)
    this._appData.socialRoom=this.room;
  }
  public updateVideoUrl(event: Event) {
    const val = (event.target as HTMLInputElement).value;
    this.room.video=val
    this.videoSource=val
    $('#videoEmbed').attr('src', this.videoSource);
    this.save();


  }
  @ViewChild('imageForRoomCrop')  imageForRoomCrop!: ElementRef;

  cropper: any;
  imageSrc: string | null = null;
  croppedImage: string | null = null;

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const reader = new FileReader();
    reader.onload = () => {
      this.imageSrc = reader.result as string;

      // wait image render
      setTimeout(() => this.initCropper());
    };
    reader.readAsDataURL(input.files[0]);
    this.croppedImage=null;
  }

  initCropper() {
    if (this.cropper) {
      this.cropper.destroy();
    }
    const CropperConstructor =(window as any).Cropper?.default || (window as any).Cropper;
    this.cropper = new CropperConstructor(this.imageForRoomCrop.nativeElement, {
      aspectRatio: 2 / 1,
      viewMode: 1,
      dragMode: 'move',
      autoCropArea: 1,
      cropBoxResizable: true,
      cropBoxMovable: true,
      zoomable: true
    });
  }
  uploadVideo(fileInput: any) {
     var file = fileInput.target.files[0];
      this._auth.uploadToFirebase(
        file,
        'advMovie.mp4',
        `events/1592880902713/rooms/${this.room.id}/media/advertise/`
      ).subscribe(snapshot => {
        snapshot.ref.getDownloadURL().then(url => {
          console.log('Uploaded image URL:', url);
          this.room.video=url;
          this.videoSource=this.room.video;
          document.getElementById('videoUrl')['value']=this.videoSource
          $('#videoEmbed').attr('src', this.videoSource);
          this.save();
        });
      });
    }


  cropImage() {
    const canvas =  this.cropper.getCroppedCanvas({
      width: 600,
      height: 300,
      imageSmoothingEnabled: true,
      imageSmoothingQuality: 'high'
    });

    this.croppedImage = canvas.toDataURL('image/png');
    canvas.toBlob((blob) => {
      if (!blob) return;

      const file = new File(
        [blob],
        'cropped.png',
        { type: 'image/png' }
      );

      this._auth.uploadToFirebase(
        file,
        'advImage.png',
        `events/1592880902713/rooms/${this.room.id}/media/advertise/`
      ).subscribe(snapshot => {
        snapshot.ref.getDownloadURL().then(url => {
          console.log('Uploaded image URL:', url);
          this.room.photo=url;
          this.save();
        });
      });
    }, 'image/png');
  }

}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/social/advertising/advertising.ts